import React, { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import {CircularProgress,LinearProgress, Chip, Paper, Typography, Tooltip, IconButton, useTheme, Button } from "@material-ui/core";

import { NoRecord } from "../../components";

import { Add, ChevronLeft } from "@material-ui/icons";
import { pathOr } from "ramda";
import { MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import { Link } from "react-router-dom";

import { getSubpanelListViewData, deleteRelationship, setRelationship, closeActivity } from "../../store/actions/subpanel.actions";
import useStyles, { getMuiTheme } from "./styles";
import { Alert } from "../../components";
import SkeletonShell from "../../components/Skeleton/index";
import QuickCreate from "../DetailView/components/quickCreate/quickCreate";
import { QuickComposeEmail } from "../Emails/components";
import { getEmailCreateView } from "../../store/actions/emails.actions";
import FormInput from "../FormInput";
import SelectAllIcon from '@material-ui/icons/SelectAll';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from "react-toastify";
import { TableCell } from '@material-ui/core';
import { saveAs } from 'file-saver';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileViewerComp from "../FileViewer/FileViewer";

const SubPanelListView = ({
  module,
  subpanel,
  subpanel_module,
  title, record,
  setIsSubpanelUpdated,
  value, setValue
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { emailCreateViewLoading } = useSelector((state) => state.emails);
  const [alertVisible, setAlertVisibility] = useState(false);
  const [relateFieldData, setRelateFieldData] = useState({});
  const [loading, setLoading] = useState(false);
  
  const [activityRecord, setActivityRecord] = useState("");
  const [rel, setRel] = useState("");

  const [openQuickCreateDialog, setOpenQuickCreateDialog] = useState(false);
  const [whichQuickCreate, setWhichQuickCreate] = useState(null);
  const [emailModalVisible, setEmailModalVisible] = useState(false);

  const [sortOrderCustom, setsortOrderCustom] = useState("ASC")
  const [CurrentOrder, setCurrentOrder] = useState()
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [anchorElActionButton, setAnchorElActionButton] = React.useState(null);
  const openActionButton = Boolean(anchorElActionButton);
  const [openRelatedTo, setOpenRelatedTo] = useState(false);
  const [isRelationshipAdded, setIsRelationshipAdded] = useState(false);
  const sortBy = pathOr("", ['data', 'templateMeta', 'sort'], relateFieldData[module]);
	const sortOrder = pathOr("", ['data', 'templateMeta', 'sortOrder'], relateFieldData[module]);
  const [lastListViewSort, setLastListViewSort] = useState({ 'name': sortBy, 'direction': sortOrder });
  
  const [SortByNEWObj, setSortByNEWObj] = useState({name:sortBy,order:sortOrder})
  //const [isLoaded, setIsLoaded] = useState(false);
  
  const [previewFile, setPreviewFile] = useState({open:false,filename:"",filepath:""});
  

  useEffect(() => {
    if(relateFieldData)
    {
      setRel(relateFieldData?.templateMeta?.data.subpanel_tabs[0]?.rel_module)
    }
  }, [rel,relateFieldData])

  const changePageOrSort = async ({page, name , order}) => {
    try {
      if(typeof page==='undefined') return;
      setLoading(true); 
      setListViewMeta({ page });
      const res = await getSubpanelListViewData(module, subpanel, subpanel_module, record, 20, page + 1, name , order)
      if (res.ok) {
        await setRelateFieldData(res.data.data);
        await setRel(res?.data?.data?.templateMeta?.data.subpanel_tabs[0]?.rel_name)
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
    };
  
  useEffect(() => {
    changePageOrSort(SortByNEWObj);    
  }, [SortByNEWObj])
  function truncate(str,n) {
    return str?.length > n ? str.substr(0,n-1) + "..." : str;
  }
  const  handleShowPreviewFile = (fname,url) =>{
    let arr = fname.split(".");
    let ext = arr[arr.length-1].toUpperCase();
    setPreviewFile({open:true,filename:fname,filepath:url,filetype:ext});
  }


  let relateField = {
    comment: null,
    field_key: "relatedRecords",
    label: subpanel_module,
    massupdate: "false",
    name: "relatedRecords",
    required: "false",
    type: "relate",
    module: subpanel_module,
  };
  const handleClick = (event, dataIndex) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(dataIndex);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  const handleClickActionButton = (event) => {
    setAnchorElActionButton(event.currentTarget);
  };

  const handleCloseActionButton = () => {
    setAnchorElActionButton(null);
  };
  const handleChange = (field, val) => {
    let param = {
      "data": []
    };
    if (field === 'relatedRecords') {
      let innerData = []
   
      if(val){
      Object.values(val).map((id) => (
        innerData.push({ 'type': subpanel_module, 'id': id })
      ))
      }

      param = {
        "data": innerData
      };
    } else {
      param = {
        "data":
          [
            {
              "type": subpanel_module,
              "id": val.id
            }
          ]
      };
    }
    dispatch(setRelationship(module, record, param)).then(function (res) {
    
      if (res && res.meta) {
        toast(res.meta.message);
        setIsRelationshipAdded(true);
        setIsSubpanelUpdated(true)
        setValue(value)
      } else {
        //toast('Something went wrong!');
      }
      // console.log("rrrrrrrrrres", res)
    });
  };

  const currentSelectedModule = useSelector((state) =>
    pathOr(subpanel, ["modules", "selectedModule"], state),
  );
  const [listViewMeta, setListViewMeta] = useState({
    page: 0,
  });
  const config = useSelector((state) => state.config);
  const site_url = pathOr("", ["config", "site_url"], config);
  const statusBackground = pathOr([], ["config", "fields_background", subpanel_module], config);
  let statusField = Object.keys(statusBackground);

  const classes = useStyles();
  const theme = useTheme();
  const handleOpenQuickCreateDialog = (option, actionName) => {
    if (option === 'Create') {
      if (actionName !== 'Emails') {
        setOpenQuickCreateDialog(!openQuickCreateDialog);
        setWhichQuickCreate(actionName);
      } else {
        dispatch(getEmailCreateView()).then(function (res) {
          // emailAsPdfAction('emailpdf')
          setEmailModalVisible(!emailModalVisible);
        });
      }
    } else {
      setOpenRelatedTo(!openRelatedTo)
    }
    handleCloseActionButton()
  };

  const fetchSupanelListViewData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getSubpanelListViewData(module, subpanel, subpanel_module, record,10,listViewMeta.page + 1);
      if (res.ok) {
        setRelateFieldData(res.data.data);
      }
      setLoading(false);
    } catch (ex) {
      setLoading(false);
    }
    setIsRelationshipAdded(false)
  }, [module, subpanel, subpanel_module, record, isRelationshipAdded]);

  useEffect(() => {
    fetchSupanelListViewData();
  }, [fetchSupanelListViewData]);

  useEffect(() => {
    setLastListViewSort({ 'name': sortBy, 'direction': sortOrder })
  }, [subpanel_module]);

  const renderLoader = () => (
    <>
      <SkeletonShell layout='Subpanel' />
      {/* <div className={classes.progressWrapper}>
          <LinearProgress />
        </div> */}
    </>
  );
  const confirmDeleteRelationship = (module, record, relationship, relateId,rel) => {
  
    setAlertVisibility(true);
    setActivityRecord({ rel:rel ,module: module, record: record, relationship: relationship, relateId: relateId, function: "deleteRelationshipRecord", msg: "Are you sure you want to remove this relationship? Only the relationship will be removed. The record will not be deleted.", title: 'Remove Record' });

  };
  const confirmCloseActivity = (module, record, relationship, relateId) => {
   
    setAlertVisibility(true);
    setActivityRecord({ module: module, record: record, relationship: relationship, status: relationship === 'Tasks' ? 'Completed' : 'Held', relateId: relateId, function: "closeActivity", msg: "Do you want to close this?", title: 'Close' });
  };
  const closeActivityMethod = async () => {
    setAlertVisibility(!alertVisible);
    try {
      var submitData = {
        data: {
          type: activityRecord.relationship,
          id: activityRecord.relateId,
          attributes: { 'status': activityRecord.status },
        }
      };
      let data = JSON.stringify(submitData);
      // console.log("closeActivity", submitData)
      const res = await closeActivity(data);
      if (res.data.data.id) {
        fetchSupanelListViewData();
        setIsSubpanelUpdated(true)
        setValue(value)
        toast('It was successfully closed!');

      }
    } catch (e) {
      toast("Something went wrong!");
    }
  };
  
  // console.log(relateFieldData)
  // console.log(relateFieldData?.templateMeta?.data?.subpanel_tabs[0]?.data_count)

  const deleteRelationshipRecord = async () => {
    // alert("ACTIVITY RECORD Deleting");
    //console.log(activityRecord)
    setAlertVisibility(!alertVisible);
    try {
      const res = await deleteRelationship(
        activityRecord.module,
        activityRecord.record,
        activityRecord.relationship,
        activityRecord.relateId,
        activityRecord.rel
      );
      //console.log(res)
      toast(res?.data ? res?.data?.meta?.message : res?.data?.errors?.detail);
      fetchSupanelListViewData();
      setIsSubpanelUpdated(true)
      setValue(value)
      setActivityRecord('')
    } catch (e) {
      // console.log(e);
      toast("Something went wrong!");
    }
  };
  
  const renderListView = () => {
    let dataArr = pathOr(
      [],
      ["templateMeta", "data", "subpanel_tabs"],
      relateFieldData,
    );

    dataArr = Object.entries(dataArr);
    dataArr = dataArr[0] ? dataArr[0] : [];
    dataArr = dataArr[1] ? dataArr[1] : [];

    //console.log(dataArr)
    let data = pathOr(
      [],
      ["templateMeta", "data", "subpanel_tabs", 0, "listview", "data", 0],
      relateFieldData,
    );
    let columnsArr = pathOr(
      [],
      ["templateMeta", "data", "subpanel_tabs", 0, "listview", "datalabels"],
      relateFieldData,
    );
    let editBtn = pathOr(
      [],
      ["templateMeta", "data", "subpanel_tabs", 0, "listview", "datalabels", "edit_button"],
      relateFieldData,
    );
    let removeBtn = pathOr(
      [],
      ["templateMeta", "data", "subpanel_tabs", 0, "listview", "datalabels", "remove_button"],
      relateFieldData,
    );

    let createBtn = pathOr(
      '',
      ["templateMeta", "data", "subpanel_tabs", 0, "top_buttons", 0, "widget_class"],
      relateFieldData,
    );
    let selectBtn = pathOr(
      '',
      ["templateMeta", "data", "subpanel_tabs", 0, "top_buttons", 1, "widget_class"],
      relateFieldData,
    );

    // let columns = columnsArr.filter((it) => it.name !== 'remove_button').map((it) => {
    // console.log("columnsArr", columnsArr)

    let columns = columnsArr.filter((it) => it.name !== 'remove_button').map((it) => {
      //console.log("it.options",it);
      //console.log("",statusField);
      if (statusField && statusField.length > 0 && statusField.some(item => it.name === item)) {
        return {
          ...it,
          options: {
          
            filter: false,
            customBodyRender: (value, tableMeta, updateValue) => {

              let option = (it.options) ? Object.keys(it.options).find(key => it.options[key] === value) : '';
              let optionBgColor = `${pathOr("", [it.name, option, "background_color"], statusBackground)}`;
              let statusStyle = {};

              if (theme.palette.type === 'dark') {
                statusStyle = { color: optionBgColor, fontWeight: 'bolder', background: 'transparent', border: '1px solid' };

              } else {
                statusStyle = { color: optionBgColor, background: optionBgColor + "20", border: 'none', };
              }
              return (
                value && optionBgColor ? <Chip size="small" className={classes.statusBg} style={statusStyle} label={value} /> : value
              )
            }
          }
        }
      }
      if (it.name === "name" || it.name === "full_name" || it.name === "first_name" || it.name === "last_name" || it.name === 'document_name') {
        return {
          ...it,
          options: {
            filter: false,
            customBodyRender: (value, tableMeta, updateValue) => {
              // console.log("data=========",data)
              let viewAcl = pathOr(0, ['ACLAccess', 'view'], data[tableMeta["rowIndex"]]);
              const id = data[tableMeta["rowIndex"]].id;
              const redirectModule = subpanel_module === 'History' || subpanel_module === 'Activities' ? data[tableMeta["rowIndex"]].object_image : subpanel_module;
              //  let emailUrl ='';
              //   if(redirectModule==="Emails"){
              //     const msgno = data[tableMeta["rowIndex"]].msgno;
              //     const uid = data[tableMeta["rowIndex"]].uid;
              //     emailUrl = `/${msgno}/${uid}`;
              //   }
              if(viewAcl == 1)
              {
                return(
                  <Typography>
                    <Link
                      to={`/app/detailview/${redirectModule}/${id}`}
                      // to={`/app/detailview/${redirectModule}/${id}${emailUrl}`}
                      className={classes.link}
                      variant="body2"
                    >
                      {value}
                    </Link>
                  </Typography>
                )
              }
              else
              {
                return(
                  <Typography>
                    {value}
                  </Typography>
                )  
              };
            },
          },
        };
      }
      else if (it.type === "relate") {
        return {
          ...it,
          options: {
            filter: false,
            customBodyRender: (value, tableMeta, updateValue) => {
              const ss = it.id_name;
              // console.log("IT Data", data);
              const parent_id = data[tableMeta["rowIndex"]][ss];
              const parent_type = it.module;

              return (
                <Typography>
                  <Link
                    to={`/app/detailview/${parent_type}/${parent_id}`}
                    className={classes.link}
                    // component="button"
                    variant="body2"
                  >
                    {value}
                  </Link>
                </Typography>
              );
            },
          },
        };
      }
      else if (it.type === "parent") {
        return {
          ...it,
          options: {
            filter: false,
            customBodyRender: (value, tableMeta, updateValue) => {
              const parent_id = data[tableMeta["rowIndex"]].attributes.parent_id;
              const parent_type = data[tableMeta["rowIndex"]].attributes.parent_type;

              return (
                <Typography>
                  <Link
                    to={`/app/detailview/${parent_type}/${parent_id}`}
                    className={classes.link}
                    // component="button"
                    variant="body2"
                  >
                    {value}
                  </Link>
                </Typography>
              );
            },
          },
        };
      }
      else if (it.name === "edit_button") {
        return {
          name: "Actions",
          options: {
            filter: false,
            customHeadRender: (columnMeta, updateDirection) => (
              <TableCell
                variant='head'
                align="right"
                className={classes.headRightBtn}>
                Action
              </TableCell>
            ),
            customBodyRender: (value, tableMeta, updateValue) => {
              let editAcl = pathOr(0, ['ACLAccess', 'edit'], data[tableMeta["rowIndex"]]);
              let deletAcl = pathOr(0, ['ACLAccess', 'delete'], data[tableMeta["rowIndex"]]);
              
              const id = data[tableMeta["rowIndex"]].id;
              const redirectModule = subpanel_module === 'History' || subpanel_module === 'Activities' ? data[tableMeta["rowIndex"]].object_image : subpanel_module;

              return (
                <div className={classes.rightBtn}>
                  { editAcl ==1 ? 
                  <IconButton size="small" aria-label="edit"
                    onClick={() =>
                      history.push(
                        "/app/editview/" + redirectModule + "/" + id,
                      )
                    }>
                    <EditIcon />
                  </IconButton>
                  :""}
                  { deletAcl ==1 ?
                  <IconButton size="small" aria-label="delete"
                    onClick={() => {
                      // setRel()
                      // alert(rel)
                      confirmDeleteRelationship(module, record, redirectModule.toLowerCase(), id,rel)
                      }}>
                    <DeleteIcon />
                  </IconButton>
                  :""}
                 
                </div>
              );
            },
          },
        };
      } else if (it.name === "close_button") {
        return {
          name: "Close",
          options: {
            filter: false,
            customHeadRender: (columnMeta, updateDirection) => (
              <TableCell
                variant='head'
                align="right"
                className={classes.headRightBtn}>
                Close
              </TableCell>
            ),
            customBodyRender: (value, tableMeta, updateValue) => {
              const id = data[tableMeta["rowIndex"]].id;
              const redirectModule = subpanel_module === 'History' || subpanel_module === 'Activities' ? data[tableMeta["rowIndex"]].object_image : subpanel_module;
              let editAcl = pathOr(0, ['ACLAccess', 'edit'], data[tableMeta["rowIndex"]]);

              return (((redirectModule === 'Calls' && data[tableMeta["rowIndex"]].status !== 'Held') || (redirectModule === 'Meetings' && value !== 'Held') || (redirectModule === 'Tasks' && value !== 'Completed')) ?
                <div className={classes.rightBtn}>
                  { editAcl ==1 ? 
                  <IconButton size="small" aria-label="close"
                    onClick={() => confirmCloseActivity(module, record, redirectModule, id)}>
                    <CloseIcon />
                  </IconButton>
                  :""}
                </div> : null
              );
            },
          },
        };
      }
      else if(it.name==='opportunities_scoring_c' || it.name==='lead_scoring_c')
      {
        return {
          ...it,
          options: {
            filter: false,
            customBodyRender: (value, tableMeta, updateValue) => {
              let tmp = document.createElement("SPAN");
              tmp.innerHTML = value;
              value = tmp.textContent || tmp.innerText || "";
              return (
                <Typography>
                  {value || ""}
                </Typography>                
              );
            }
          }
        };
      }
       else if (it.type === "file" || it.name === 'document_name') {
        return {
          ...it,
          options: {
            filter: false,
            sort: false,
            customBodyRender: (value, tableMeta, updateValue) => {
              let furl = `${site_url}/index.php?entryPoint=customDownload&id=${data[tableMeta["rowIndex"]].id}&type=Documents`;
              return (
                value ?
                <Typography>
                  <VisibilityIcon fontSize='small' style={{margin:"-1vh",marginLeft:"1vh",marginRight:"1vw",cursor:"pointer"}}    onClick={()=>handleShowPreviewFile(value,furl)} />
                    <Tooltip title={value}>
                      <Link to={`#`} className={classes.link} onClick={() => {saveAs(furl, data[tableMeta["rowIndex"]].filename);toast("Downloading in progress!");}} variant="body2">
                      {truncate(value,20) || truncate(data[tableMeta["rowIndex"]].document_name,20) || ""}
                    </Link>
                  </Tooltip>
                </Typography> : ""                
              );
            },
          },
        };
      }
      return it;
    });
  
    const renderCustomToolbar = () => {
      return (<React.Fragment>
        <Tooltip title={"add record"}>
          <IconButton onClick={() => { }}>
            {/* <Add /> */}
          </IconButton>
        </Tooltip>
      </React.Fragment>)
    }

    const renderSubpanelButtons = props => {
      let p = props.buttonLayout;
      return (<div className={classes.optionWrapper} > {subpanel_module !== 'Activities' && subpanel_module !== 'History' && subpanel_module !== 'SecurityGroups' ?
        

        <div className={p == 'floatcenter' ? classes.floatcenter : classes.floatCstm}>
          {createBtn !== '' ? <Button variant="outlined" style={{marginRight:10}} color="primary" size="small" onClick={() => handleOpenQuickCreateDialog('Create', subpanel_module)}
          ><Add /> Create </Button> : null}
          {selectBtn !== '' ? <FormInput
            variant="outlined"
            className={classes.textArea}
            field={relateField}
            initialValues={{ 'relatedRecords': [] }}
            value=''
            // setModalVisible={openRelatedTo}
            multiSelect="true"
            isIconBtn="true"
            isSelectBtn="true"
            btnIcon={<SelectAllIcon />}
            color="primary"
            disabled={false}
            onChange={(val) => { handleChange("relatedRecords", val) }}
          /> : null}
          {/* <a className={classes.floatCstm} onClick={() => handleOpenQuickCreateDialog('Select', subpanel_module)}
        ><Add /> Select </a> */}
        </div>
        : null}</div>)
    }
    
    return (
      <>
       
        {
          (data.length > 0) ?
            <div>
              {renderSubpanelButtons({ buttonLayout: "floatCstm" })}
              <MuiThemeProvider theme={getMuiTheme(theme)}>
                <MUIDataTable
                  title={<Typography component={'span'} variant="subtitle1"></Typography>}
                  data={data.map((it) => it)}
                  columns={columns}
                  options={{
                    filter: false,
                    download: false,
                    responsive: "vertical",
                    serverSide: true,
                    count: relateFieldData?.templateMeta?.data.subpanel_tabs[0]?.data_count,
                    rowsPerPage: 10,
                    page: listViewMeta.page,
                    rowsPerPageOptions: false,
                    selectableRows:false,
                    selectableRowsHeader:false,
                     fixedHeader: true,
                    // fixedSelectColumn: true,
                    search: false,
                    print: false,
                    viewColumns: false,
                    // selectableRows: meta["total-records"] ? true : false,
                    pagination: relateFieldData?.templateMeta?.data.subpanel_tabs[0]?.data_count > 0 ? true : false,
                    sortOrder:sortOrderCustom,
                   customToolbar: () => renderCustomToolbar(),
                    onTableChange: (action, tableState) => {
                      const newVal = {}
                      newVal.name = tableState.sortOrder.name;
                      newVal.order = tableState.sortOrder.direction;
                      newVal.page = tableState.page;
                      if(newVal.name!=="" && newVal.order!=="" && tableState.sortOrder.name)
                      {
                        setSortByNEWObj({...newVal})
                      }
                      let directionToSort;
                      switch (action) {
                        case "changePage":
                          if (tableState.sortOrder.hasOwnProperty("name")) {
                            //let directionToSort =tableState.sortOrder.direction === "desc"? `DESC`: "ASC";
                            setSortByNEWObj((prevstate)=>({
                              ...prevstate,
                              page:tableState.page
                            }))
                            // changePageOrSort(tableState.page,SortByNEWObj);
                            break;
                          }
                            setSortByNEWObj((prevstate)=>({
                              ...prevstate,
                              page:tableState.page
                            }))
                            // changePageOrSort(tableState.page,SortByNEWObj);
                          break;

                        case "sort":
                          if(SortByNEWObj.order==="DESC" || SortByNEWObj.order==="")
                          {
                            setSortByNEWObj((prevstate)=>({
                              ...prevstate,
                              order:"ASC"
                            }))
                          }
                          else
                          {
                            setSortByNEWObj((prevstate)=>({
                              ...prevstate,
                              order:"DESC"
                            }))
                          }

                          break;
                        default:
                          // console.log("action not handled.");
                      }
                  },
                  }}
                />
              </MuiThemeProvider>
            </div>
            : <div>
              {!loading?<NoRecord view='subpanel' subpanel_module={subpanel_module} module={module} />:""}
              {renderSubpanelButtons({ buttonLayout: "floatcenter" })}
            </div>
        }

      </>
    );
  };

  const renderBody = () => {
    return (
      <Paper square className={classes.paper}>
        {loading ? renderLoader() : renderListView()}
      </Paper>
    );
  };

  return (
    <>
      {renderBody()}
      <Alert
        title={activityRecord.title}
        msg={activityRecord.msg}
        open={alertVisible}
        agreeText={"Yes"}
        disagreeText={"No"}
        handleClose={() => setAlertVisibility(!alertVisible)}
        onAgree={activityRecord.function === 'closeActivity' ? closeActivityMethod : deleteRelationshipRecord}
      />
      {openQuickCreateDialog ? <QuickCreate openQuickCreateDialog={openQuickCreateDialog} setIsSubpanelUpdated={setIsSubpanelUpdated} setValue={setValue} value={value} setOpenQuickCreateDialog={setOpenQuickCreateDialog} whichQuickCreate={whichQuickCreate} parent_name={title} parent_id={record} parent_type={module}


      /> : null}
      {emailModalVisible && !emailCreateViewLoading ? (<QuickComposeEmail
        modalState={emailModalVisible}
        handleClose={() => { setEmailModalVisible(!emailModalVisible); }}
      />) : null}

      {(previewFile.open) ? <FileViewerComp previewFile={previewFile} setPreviewFile={setPreviewFile} /> : ""}
    </>
  );
};

export default SubPanelListView;
